import React, { useContext } from "react";
import PropTypes from "prop-types";
import { SimpleContext } from "../../../store/context/simple-context";
import { FONTS_STYLES } from "../../../helpers/constants";
import { getTrueClasses } from "../../../helpers";
import MainTitle from "./MainTitle";
import Toggle from "./Toggle";
import StickyBlock from "./StickyBlock";
import Options from "./Options";
import Table from "./Table";
import Call from "./Call";
import "../../../assets/scss/fonts/cnFonts.scss";
import "../../../assets/scss/fonts/jpFonts.scss";
import "../../../assets/scss/fonts/localization.scss";
import "./index.scss";
import "./local.scss";

const Customizable = (props) => {
  const {
    refs: {
      pricingRef,
      toggleRef,
      tableRef,
      monthlyNavRef,
      yearlyNavRef,
      lifetimeNavRef,
      optionsRef,
      stickyBlockRef,
      containerRef,
    },
    position,
  } = props;

  const {
    modes: { mode, customClass },
    translate: { language },
  } = useContext(SimpleContext);

  return (
    <section
      className={getTrueClasses(
        "GP-C",
        FONTS_STYLES[language],
        language !== "en" && `GP-C_${language}`,
        mode && `GP-C_${mode}`,
        customClass
      )}
      ref={pricingRef}
      id="pricing"
    >
      <MainTitle />
      <div
        className={getTrueClasses(
          "GP-C__container",
          mode && `GP-C__container_${mode}`
        )}
        ref={containerRef}
      >
        <div className="GP-C__offer">
          <Toggle
            refs={{
              toggleRef,
              monthlyNavRef,
              yearlyNavRef,
              lifetimeNavRef,
            }}
          />
          <Table tableRef={tableRef} />
          <Options optionsRef={optionsRef} />
          {language === "en" && <Call />}
        </div>
        <StickyBlock {...position} stickyBlockRef={stickyBlockRef} />
      </div>
    </section>
  );
};

Customizable.propTypes = {
  refs: PropTypes.object,
  position: PropTypes.object,
};

export default Customizable;
